// extracted by mini-css-extract-plugin
module.exports =  {"layout":"_33974c2b58--layout--TjvSZ","spinner":"_33974c2b58--spinner--uIpxO","container":"_33974c2b58--container--O_TQ1","error":"_33974c2b58--error--bfnyQ"};